/**
 * @description This helper wraps your click handler to ensure only fired when Enter or Spacebar is pressed.
 */
const onEnterAndSpace: (
  arg0: (arg0: React.SyntheticEvent<any>) => void,
) => (arg0: React.KeyboardEvent<any>) => void = (fn) => (event) =>
  event.key === "Enter" || event.key === " " ? fn(event) : undefined;

export default onEnterAndSpace;
